import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("oda_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("oda_token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const api = {
  login: (password) => client.post("/auth/login", { password }).then((r) => r.data),
  verify: () => client.get("/auth/verify").then((r) => r.data),
  listMembers: () => client.get("/members").then((r) => r.data),
  createMember: (data) => client.post("/members", data).then((r) => r.data),
  updateMember: (id, data) => client.put(`/members/${id}`, data).then((r) => r.data),
  deleteMember: (id) => client.delete(`/members/${id}`).then((r) => r.data),
  bulkUpdateStatus: (ids, status) =>
    client.post("/members/bulk-status", { ids, status }).then((r) => r.data),
  bulkUpdateEntityType: (ids, entity_type) =>
    client.post("/members/bulk-entity-type", { ids, entity_type }).then((r) => r.data),
  votes: () => client.get("/votes").then((r) => r.data),
  setVote: (id, vote, by = "") =>
    client.put(`/members/${id}/vote`, { vote, by }).then((r) => r.data),
  vcardBirak: (metin, ad) => client.post("/vcard", { metin, ad }).then((r) => r.data),
  vcardUrl: (kod) => `${API}/vcard/${kod}`,
  settings: () => client.get("/settings").then((r) => r.data),
  updateSettings: (data) => client.put("/settings", data).then((r) => r.data),
  stats: () => client.get("/stats").then((r) => r.data),
  snapshots: (days = 30) =>
    client.get("/snapshots", { params: { days } }).then((r) => r.data),
  exportCsvUrl: () => `${API}/members/export`,
  importCsv: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client.post("/members/import", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },
};

export default client;
